import type { PostMedia } from "../../types";
import type { GameTrailer } from "../../types/game";

/**
 * Transforms game media data (trailers + screenshots) into the PostMedia[]
 * format expected by the MediaCarousel component.
 *
 * - Places trailers first as 'video' type items
 * - Follows with screenshots in original order as 'image' type items
 * - All items get unique IDs
 */
export function buildCarouselMedia(
  heroUrl: string | undefined,
  screenshots: string[],
  trailers: GameTrailer[] = []
): PostMedia[] {
  return [
    // Trailers first (as video)
    ...trailers.map((trailer, i) => ({
      id: `trailer-${i}`,
      type: "video" as const,
      url: trailer.url,
    })),
    // Then screenshots (as images)
    ...screenshots.map((url, i) => ({
      id: `screenshot-${i}`,
      type: "image" as const,
      url,
    })),
  ];
}
